module.exports = __webpack_public_path__ + "img/sitting-man.eeae1a23.png";